module.exports = "/fonts/vendor/@fortawesome/fontawesome-pro/webfa-light-300.eot?1980e02850f8d6c2e02280a60674f547";